module.exports = __webpack_public_path__ + "static/icons8-octocat-337615a9278c000b447d1939ec5c1c9b.svg";